export default {
  items: [
    {
      name: 'Dashboard',
      url: '/eventtags/dashboard',
      icon: 'icon-speedometer',
    },
    {
      name: 'Manage Organizer',
      url: '/eventtags/eventorganizer', // ok 1
      icon: 'icon-people',
    },
    {
      name: 'Events',
      icon: 'icon-star',
      children: [
        {
          name: 'Manage Events',
          url: '/eventtags/events',
          icon: 'icon-star',
        },
        {
          name: 'Sub Event Feedbacks',
          url: '/eventtags/subeventfeedbacks',
          icon: 'icon-star',
        },
        {
          name: 'Speaker Feedbacks',
          url: '/eventtags/speakerfeedbacks',
          icon: 'icon-star',
        }
      ]
    },
    // {
    //   name: 'Manage Speakers',
    //   url: '/eventtags/publicspeaker',
    //   icon: 'icon-people',
    // },
    {
      name: 'Review Participants',
      icon: 'icon-people',
      children: [
        {
          name: 'Check IN',
          url: '/eventtags/eventorganizer/dashboard',
          icon: 'icon-star',
        },
        {
          name: 'Registered Participants',
          url: '/eventtags/eventorganizer/checked-participants',
          icon: 'icon-star',
        },
        {
          name: 'View All Checked IN Participants',
          url: '/eventtags/eventorganizer/checked-participants',
          icon: 'icon-star',
        },
        {
          name: 'Question Bank',
          url: '/eventtags/eventorganizer/question-bank',
          icon: 'icon-star',
        }
      ]
    },
    {
      name: 'Notifications',
      icon: 'icon-bell',
      children: [
        {
          name: 'Send Notification',
          url: '/eventtags/notifications/create', // ok 1
          icon: 'icon-bell',
        },
        {
          name: 'View Notifications',
          url: '/eventtags/notifications/view', // ok 1
          icon: 'icon-bell',
        }
      ]
    }
    ]
};
